(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifAccordion', swifAccordion)
    .directive('swifAccordionGroup', swifAccordionGroup)
    .directive('swifAccordionHeading', swifAccordionHeading)
    .directive('swifAccordionTransclude', swifAccordionTransclude);


    /**
        * @ngdoc directive
        * @name swif.ui:swifAccordion
        * @module swif.ui
        * @restrict EA
        * @description just overwrite template of the uib-accoordion directive
        * http://angular-ui.github.io/bootstrap/#/accordion
        * @usage
        <swif-accordion>
            <swif-accordion-group heading="{{::'Interventions' | translate}}">
            </swif-accordion-group>
            <swif-accordion-group heading="{{::'Patrimoine' | translate}}">
            </swif-accordion-group>
        </swif-accordion>
    **/
    function swifAccordion() {
        return {
            restrict:'EA',
            controller:'UibAccordionController',
            transclude: true,
            replace: false,
            templateUrl: 'partials/ui/swif_accordion.html'
        };
    }

    function swifAccordionGroup() {
        return {
            require:'^swifAccordion',         // We need this directive to be inside an accordion
            restrict:'EA',
            transclude:true,              // It transcludes the contents of the directive into the template
            replace: true,                // The element containing the directive will be replaced with the template
            templateUrl:'partials/ui/swif_accordion_group.html',
            scope: {
                heading: '@',               // Interpolate the heading attribute onto this scope
                isOpen: '=?',
                isDisabled: '=?',
                onOpen: '&?',
                onClose: '&?'
            },
            controller: function() {
                this.setHeading = function(element) {
                    this.heading = element;
                };
            },
            link: function(scope, element, attrs, accordionCtrl) {
                accordionCtrl.addGroup(scope);

                scope.$watch('isOpen', function(value) {
                    if ( value ) {
                        accordionCtrl.closeOthers(scope);
                        if (scope.onOpen) {
                            scope.onOpen({});
                        }
                    } else if (scope.onClose) {
                        scope.onClose({});
                    }
                });

                scope.toggleOpen = function() {
                    if ( !scope.isDisabled ) {
                        scope.isOpen = !scope.isOpen;
                    }
                };
            }
        };
    }


    function swifAccordionHeading() {
      return {
        restrict: 'EA',
        transclude: true,   // Grab the contents to be used as the heading
        template: '',       // In effect remove this element!
        replace: true,
        require: '^swifAccordionGroup',
        link: function(scope, element, attr, accordionGroupCtrl, transclude) {
          // Pass the heading to the accordion-group controller
          // so that it can be transcluded into the right place in the template
          // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
          accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
        }
      };
    }

    function swifAccordionTransclude() {
        return {
            require: '^swifAccordionGroup',
            link: function(scope, element, attr, controller) {
                scope.$watch(function() { return controller[attr.swifAccordionTransclude]; }, function(heading) {
                    if (heading) {
                      element.find('span').html('');
                      element.find('span').append(heading);
                    }
                });
            }
        };
    }

})();
